import { render } from "./ProductTab.vue?vue&type=template&id=75926bab"
import script from "./ProductTab.vue?vue&type=script&lang=js"
export * from "./ProductTab.vue?vue&type=script&lang=js"

import "./ProductTab.vue?vue&type=style&index=0&id=75926bab&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__